import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from '../../utils/classNames';
import styles from './SearchResults.module.css';
const SearchResults = ({ active, children, className, color, }) => {
    const renderContent = () => (_jsxs("div", Object.assign({ className: classNames(!children || React.Children.count(children) === 0
            ? styles.noResults
            : '') }, { children: [(!children || React.Children.count(children) === 0) && (_jsx("h4", { children: "Sorry, no results found" }, void 0)), (!children || React.Children.count(children) === 0) && (_jsx("p", { children: "Why dont you try another keyword?" }, void 0)), children] }), void 0));
    return active ? (_jsx("div", Object.assign({ className: classNames(styles.wrapper, color === 'ambient' ? styles.ambient : null, color === 'accent' ? styles.accent : null, color === 'shade' ? styles.shade : null, className) }, { children: renderContent() }), void 0)) : null;
};
export default SearchResults;
